import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractRequestDelivery extends BaseModelAPI {
	static entity = 'newobject1952';
	static entityName = 'subcontractrequestdelivery';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.requestDeliveryNumber = '';
			this.id = '';
			this.purchaseOrderId = '';
			this.purchaseOrder = {};
			this.vendorId = '';
			this.vendor = {};
			this.documentStatusId = '';
			this.documentStatus = {};
			this.deliveryDate = '';
			this.remarks = '';
			this.subcontractRequestDeliveryDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async printSCC(this_, ids) {
		return this_.$http.post(`${this.entityName}/printscc/`, ids)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printPdfCustom(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		//let ids = _this.$store.state.dataIds;
		return this_.$http.get(`${this.entityName}/printrequestdelivery/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}